import {GetJwtToken} from "../../views/global";
import {mPrint} from "../mPrint";
import {GetAPIBaseURLByService} from "./api";

export enum ResponseCode {
    OK= 0,
    Fail= 1,
}

const parseJSON = (response: any) => {
    if (response.status === 204 || response.status === 401) {
        return { status: response.status };
    }
    return response.json();
}

const checkStatus = (response: any) => {
    if (response.ok) {
        return response;
    }
    if (response.status === 401){
        // LoginTools.logOut();
        mPrint("login timeout")
    }

    const error = new Error(response.statusText);
    error.message = response;
    throw error;
}

const request = (url: string, options: any) => {
    const BaseUrl = GetAPIBaseURLByService()
    const requestUrl = `${BaseUrl}${url}`;
    mPrint(requestUrl + "\n")
    if (options.body) {
        mPrint(options.body + "\n")
    }

    const token = GetJwtToken()
    return fetch(requestUrl, Object.assign({}, {
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + token,
        },
    }, options))
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            mPrint(url, " - response: ", data)
            return data;
        })
        .catch(err => {
            mPrint(url, " - error: ", err)
            throw err
        });
}

const post = (url: string, param = {}) => request(url, {
    body: JSON.stringify(param),
    method: "POST",
})

const get = (url: string) => request(url, {
    method: "GET",
})

export const sendGetRequest = (api: string, success: (data: any) => void, fail?: (error?: any) => void) => {
    get(api).then((response) => {
        success && success(response)
    })
        .catch((error) => {
            fail && fail(error)
        })
}

export const sendRequest = (api: string, param: object, success: (data: any) => void, fail?: (error?: any) => void) => {
    post(api, param).then((response) => {
        success && success(response)
    })
        .catch((error) => {
            fail && fail(error)
        })
}
